@if (loaderIcon | async) {
  <app-loader [isPaymentRefund]="true" [initiatedVoidCC]="initiatedVoidCC"
    [showPaymentMessage]="refundInProgress" [retryTransactionStatus]="retryTransactionStatusLoader"
  [isTDEmv]="isTDEmv"></app-loader>
}
@if (showPage) {
  <div class="Rentalpayment customer_rental">
    <div class="row justify-content-center mt-3">
      <div class="paymentTable-container">
        <h5>Refund</h5>
        <div class="d-flex justify-content-center align-items-center payment_qty_sec">
          <a class="pay_minus" (click)="removeRow()"><i class="fa fa-minus"></i></a>
          <input type="text" [(ngModel)]="refundCount" readonly>
          <a class="pay_pluse" (click)="addRow()"><i class="fa fa-plus"></i></a>
        </div>
        <div class="d-flex justify-content-end payment_tot_amt">
          <p>Total Amount: {{totalAmount| currency}}</p>
        </div>
        <div class="scroll_outer">
          <div class="scroll_inner">
            <div id="tableScrollable" class="normal_table">
              <table class="table table-striped text-center table-hover mb-0 table-layout-inherit">
                <colgroup>
                <col width="25%">
                <col width="25%">
                <col width="50%">
              </colgroup>
              <thead>
                <tr>
                  <th scope="col" class="text-start">Refund</th>
                  <th scope="col" class="text-start">Mode</th>
                  <th scope="col" class="text-start">Amount</th>
                </tr>
              </thead>
            </table>
            <div class="lookup-table" id="PaymentScroll">
              <table class="table table-striped text-center table-hover mb-0" id="scrollcall">
                <colgroup>
                <col width="25%">
                <col width="25%">
                <col width="50%">
              </colgroup>
              <tbody>
                @for (drow of refundTable; track drow) {
                  <tr [class.disabledPayedRow]="drow.payComplete">
                    <td scope="col" class="align-middle text-start">{{drow.payName}}</td>
                    <td scope="col">
                      <select class="form-select" (change)="onChangePayMode($event.target.value,drow.payId)">
                        @for (item of payModes; track item) {
                          <option [value]="item.PaymentModeId"
                            [disabled]="isPaymentModesDisabled(item.PaymentModeId, drow)"
                          [selected]="item.PaymentModeId == drow.payModeId">{{item.PaymentModeName}}</option>
                        }
                      </select>
                    </td>
                    <td scope="col">
                      <div class="d-flex justify-content-between align-items-center refund_pay_rgt">
                        <input type="text" step="0.01" [value]="drow.payAmount | currency"
                          [ngModel]="drow.payAmount | currency " [appTwoDigitDecimal]='costValueDirectiveSetting'
                          (blur)="onChangepayAmount($event,drow.payId )"
                          class="form-control col-md-6 bg_gray text-end me-1" min="0" [max]="drow.paidAmount"
                          [disabled]="disableAmount(drow.payId)">
                          <p class="payment_tot_amt mb-0">/{{drow.paidAmount | currency}}</p>
                          <div class="button_tooltip ms-1">
                            @if (!drow.payComplete) {
                              <button type="button" class="btn btn-primary cash_paynow_butt" data-bs-backdrop="static"
                                data-bs-keyboard="false"
                                (click)="ValidateBeforeonPayClick(RefundLimitModal, drow.payAmount, drow.payId, drow.payModeId,paymentSuccess,1,checkPayment)"
                              [disabled]="disableRefundNowButton(drow)">Refund Now</button>
                            }
                            @if (drow.payNowDisable) {
                              <div class="button_tooltip_modal">
                                @if (drow.payNowDisable) {
                                  <p class="mb-0">You do not have permission to Refund</p>
                                }
                                <i class="fa fa-caret-down .text-dark h2 butt_downIcon" aria-hidden="true"></i>
                              </div>
                            }
                          </div>
                          @if (drow.payComplete) {
                            <div class="bg-success text-white btn" style="width: 90px;"><i
                            class="fa fa-check"></i>
                          </div>
                        }
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end payment_tot_amt float-right">
      <p>Remaining Amount: {{remainingAmount| currency}}</p>
    </div>
  </div>
</div>
<div class="payment_bottom_button">
  <div class="pay_rgt_butt">
    @if (processRefund.Type == 10 && processRefund.RetainFullRefund) {
      <button type="button"
      class="btn btn-primary me-3" (click)="onRefundNext(0, 1, paymentSuccess, 1, checkPayment)">Next</button>
    }
    @if (!showPrintEmailRcpt) {
      <button type="button" class="btn btn-outline-primary me-3"
      (click)="onRefundCancel()">Cancel</button>
    }
  </div>
</div>
</div>
}

@if (showPayFieldsCreditForm) {
  <div class="third_party_payment payfields-embedded-shell">
    <div #payFieldsCreditDialog class="payfields-embedded-content" role="dialog" aria-modal="true" aria-labelledby="payFieldsRefundModalTitle" tabindex="-1">
      <div class="payfields-embedded-header">
        <h5 id="payFieldsRefundModalTitle">PayFields Refund</h5>
        <button type="button" class="payfields-close-btn" (click)="cancelPayFieldsCreditForm()" [disabled]="isPayFieldsCreditTokenPending || isPayFieldsCreditSubmitPending" aria-label="Close">&times;</button>
      </div>
      <div class="payfields-embedded-body">
        <h4 class="payfields-embedded-title">Order Information</h4>
        <div class="payfields-embedded-row">
          <label>Total Amount ({{getPayFieldCurrencySymbol()}}):</label>
          <span>{{payFieldsCreditPendingAmount | number: '1.2-2'}}</span>
        </div>
        <div class="payfields-embedded-row">
          <label>Transaction Type:</label>
          <span>CREDIT</span>
        </div>

        <h4 class="payfields-embedded-title">Card Information</h4>
        <div class="payfields-embedded-field-row">
          <label>Card Number:<span class="required">*</span></label>
          <div id="refund-payfields-card-number" class="payfields-secure-field"></div>
        </div>
        <div class="payfields-embedded-field-row payfields-expiry-cvv">
          <div>
            <label>Expiry Date:<span class="required">*</span></label>
            <div id="refund-payfields-card-expiration" class="payfields-secure-field"></div>
          </div>
          <div>
            <label>CVV:<span class="required">*</span></label>
            <div id="refund-payfields-card-cvv" class="payfields-secure-field"></div>
          </div>
        </div>

        <h4 class="payfields-embedded-title">Customer Information</h4>
        <div class="payfields-embedded-grid">
          <div>
            <label>First Name:<span class="required">*</span></label>
            <input class="form-control" type="text" [(ngModel)]="payFieldsCreditBillingDetails.firstName" maxlength="50" />
          </div>
          <div>
            <label>Middle Name:</label>
            <input class="form-control" type="text" [(ngModel)]="payFieldsCreditBillingDetails.middleName" maxlength="50" />
          </div>
          <div>
            <label>Last Name:<span class="required">*</span></label>
            <input class="form-control" type="text" [(ngModel)]="payFieldsCreditBillingDetails.lastName" maxlength="50" />
          </div>
          <div>
            <label>Address One:<span class="required">*</span></label>
            <input class="form-control" type="text" [(ngModel)]="payFieldsCreditBillingDetails.addressOne" maxlength="100" />
          </div>
          <div>
            <label>Address Two:</label>
            <input class="form-control" type="text" [(ngModel)]="payFieldsCreditBillingDetails.addressTwo" maxlength="100" />
          </div>
          <div>
            <label>City:<span class="required">*</span></label>
            <input class="form-control" type="text" [(ngModel)]="payFieldsCreditBillingDetails.city" maxlength="50" />
          </div>
          <div>
            <label>Country:<span class="required">*</span></label>
            <select class="form-select" [(ngModel)]="payFieldsCreditBillingDetails.countryId" (change)="onPayFieldsCreditCountryChange($event.target.value)">
              @for (ct of countryList; track ct) {
                <option [value]="ct.Id">{{ct.Name}}</option>
              }
            </select>
          </div>
          <div>
            <label>State or Province:<span class="required" *ngIf="payFieldsStateRequired && !emptyStateList">*</span></label>
            <select class="form-select" [(ngModel)]="payFieldsCreditBillingDetails.stateId" [disabled]="emptyStateList">
              <option value="0">--</option>
              @for (st of stateList; track st) {
                <option [value]="st.Id">{{st.Name}}</option>
              }
            </select>
          </div>
          <div>
            <label>Postal Code:<span class="required">*</span></label>
            <input class="form-control" type="text" [(ngModel)]="payFieldsCreditBillingDetails.postalCode" maxlength="15" />
          </div>
        </div>
      </div>
      <div class="payfields-embedded-sticky-footer">
        <div class="payfields-embedded-actions">
          @if (customerInfoPresent) {
            <label class="pure-material-checkbox mb-0 me-auto">
              <input type="checkbox" class="checkBoxClass" [(ngModel)]="isAutoPopulateBillingInfo" (change)="onPayFieldsCreditAutoPopulateChange()">
                <span class="charitypay_text mt-0">Auto Populate Customer Information</span>
              </label>
          }
          <button type="button" class="btn btn-outline-primary" (click)="cancelPayFieldsCreditForm()" [disabled]="isPayFieldsCreditTokenPending || isPayFieldsCreditSubmitPending">Cancel</button>
          <button type="button" class="btn btn-primary" (click)="submitPayFieldsCreditForm()" [disabled]="isPayFieldsCreditSubmitDisabled()">Make Refund</button>
        </div>
      </div>
      <div id="refund-payfields-submit-host" class="payfields-submit-host"></div>
    </div>
  </div>
}

<!--Host Pay starts-->
@if (showIFrame) {
  <div class="third_party_payment">
    <!--iFrame-->
    <iframe width="100%" #CNPIFrame id="CNPIFrame" height="100%" frameBorder="0" [src]="urlSafe"
    (load)="getHiddenInput()"></iframe>
    <div [ngClass]="customerInfoPresent ? 'row my-3 me-5 ms-5 autopay-footer' : 'row my-3 justify-content-end mx-0'">
      @if (customerInfoPresent) {
        <label class="pure-material-checkbox float-start">
          <input type="checkbox" class="checkBoxClass" [(ngModel)]="isAutoPopulateBillingInfo"
            (change)="onClickAutoPopulateBillingInfo(209)">
            <span class="charitypay_text mt-0">Auto Populate Customer Information</span>
          </label>
        }
        <div class="pay_rgt_butt">
          <button type="button" class="btn btn-outline-primary"
          (click)="onhstPayBtn(hstPayBtnMsg)">{{hstPayBtnMsg}}</button>
        </div>
      </div>
    </div>
  }

  @if (showAchIFrame) {
    <div class="third_party_payment">
      <iframe width="100%" #ACHIFrame id="ACHIFrame" height="100%" frameBorder="0" [src]="achUrlSafe"
      (load)="getAchHiddenInput()"></iframe>
      <div class="pay_rgt_butt">
        <button type="button" class="btn btn-outline-primary" (click)="onhstPayBtn(hstPayBtnMsg)">{{hstPayBtnMsg}}</button>
      </div>
    </div>
  }
  <!--Host Pay ends-->

  <ng-template #paymentSuccess>
    <div class="modal-body">
      <div class="row mx-0">
        @if (paymentSuccessFul) {
          <div class="payment_successful_txt">
            <app-success-tick></app-success-tick><span>{{prePayStatus}} {{payStatus}}!</span>
          </div>
        }
        @if (!paymentSuccessFul) {
          <div class="payment_failed_txt">
            <app-failure-cross></app-failure-cross><span>{{prePayStatus}} {{payStatus}}!</span>
          </div>
        }
      </div>

      @if (paymentSuccessFul && showPrintEmailRcpt) {
        <div class="row mx-0 justify-content-between">
          @if (isResponse) {
            <div class="confirmation_det w-100">
              <ul>
                <li>
                  <label class="fw-bold">Receipt#</label>
                  <span>{{apiResponse.ReceiptId}}</span>
                </li>
                <li>
                  <label class="fw-bold">Amount</label>
                  <span>{{tillNowPaid| currency}}</span>
                </li>
                <li>
                  <label class="fw-bold">Date</label>
                  <span>{{apiResponse.date | date: 'MM/dd/yyyy hh:mm:ss a'}}</span>
                </li>
              </ul>
            </div>
          }
        </div>
      }
      @if (!paymentSuccessFul) {
        <div class="row mt-4 pt-2 mx-0 text-center"><label class="w-100"><strong>Uh-oh! We Were
        Unable To Process Your Payment</strong></label></div>
      }
      @if (!paymentSuccessFul) {
        <div class="text-center">
          <div class="payment_fail_reason">
            <ul>
              <li>
                <label class="fw-bold">{{paymentFailReason}}</label>
              </li>
            </ul>
          </div>
        </div>
      }
    </div>
    @if (prePayStatus !== 'Refund' || !paymentSuccessFul) {
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" [disabled]="" (click)="onSuccesRefund()">OK</button>
      </div>
    }
  </ng-template>

  <ng-template #checkPayment>
    <div class="modal-header">
      <h5 class="modal-title">Check Payment</h5>
      <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="checkModalRef.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body common_form">
      <div class="row">
        <div class="col-md-4"><label>Amount@if (amountFieldforcheck) {
          <span class="required">*</span>
        }</label></div>
        <div class="col-md-8"><input type="text" [value]="amountToPay | currency" class="form-control" readonly />
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-4"><label>Check #@if (checknumberField) {
          <span class="required">*</span>
        }</label></div>
        <div class="col-md-8"><input type="text" [(ngModel)]="checkNo" class="form-control" maxlength="15"
          #checkfield1="ngModel" />
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-4"><label>Check Date@if (checkdatefield) {
          <span class="required">*</span>
        }</label></div>
        <div class="col-md-8">
          <ejs-datepicker Class="form-control p-0 h-auto" [(ngModel)]="checkDate" #checkdatefield2="ngModel" [max]="today"
            floatLabelType='Always' format='MM/dd/yyyy' required>
          </ejs-datepicker>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-4"><label>Bank@if (checkbankname) {
          <span class="required">*</span>
        }</label></div>
        <div class="col-md-8"><input type="text" [(ngModel)]="checkBank" #checkbankname1="ngModel" class="form-control"
          maxlength="15" />
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-primary me-3" data-bs-dismiss="modal"
      (click)="onCheckCancel()">Cancel</button>
      <button type="button" data-bs-dismiss="modal" class="btn btn-primary" [disabled]="onDisableCheck()"
      (click)="gotoPaymentSuccess(paymentSuccess,amountToPay)">Pay {{amountToPay| currency}}</button>
    </div>
  </ng-template>

  <ng-template #skipRefund>
    <div class="modal-body">
      <div class="row mt-4 pt-2 mx-0 text-center"><label class="w-100"><strong>Amount will be refunded from Corporate
      Office</strong></label></div>
      <div class="text-center">
        <div class="payment_fail_reason">

        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" [disabled]="" (click)="onSkipRefund()">OK</button>
    </div>
  </ng-template>

  <form #manualAuthForm="ngForm">
    <ng-template #manualAuthorization>
      <div class="modal-header">
        <h5 class="modal-title">Manual Authorization</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="OnmanualCancel()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body common_form Manual_auth_form">
        <div class="manual_form_row">
          <div class="manual_card">
            <label>Card # (Last 4 Digits)@if (isRequired('mManualCardNumber')) {
              <span class="required">*</span>
            }</label>
            <div class="inputbox">
              <input type="text" class="form-control" [(ngModel)]="ManualCardNumber" minlength="4" maxlength="4"
                name="mManualCardNumber" #mManualCardNumber="ngModel" (keypress)="numberOnly($event)">
                @if (manualAuthForm.form.get('mManualCardNumber').errors  &&
                  (manualAuthForm.form.get('mManualCardNumber').dirty || manualAuthForm.form.get('mManualCardNumber').touched) &&
                  manualAuthForm.form.get('mManualCardNumber').validator !== null) {
                  <div class="alert alert-danger">
                    @if (manualAuthForm.form.get('mManualCardNumber').errors.required) {
                      <span>
                      Manual Card Number is required</span>
                    }
                  </div>
                }
                @if (ManualCardNumber && ManualCardNumber.length > 0 && ManualCardNumber.length < 4) {
                  <div class="alert alert-danger"
                    >
                    <span>Credit Card number must be 4 characters long</span>
                  </div>
                }
              </div>
            </div>
            <div class="manual_card_exp">
              <label>Exp @if (isRequired('mManualCardExp')) {
                <span class="required">*</span>
              }</label>
              <div class="inputbox">
                <ejs-maskedtextbox [mask]="ExpNumberMask" type="text" [(ngModel)]="ManualCardExp" name="mManualCardExp"
                  #mManualCardExp="ngModel" (keyup)="OnChangeManualCardExp($event)">
                </ejs-maskedtextbox>
                @if (ManualCardExpIsDirty && (!ValidManualCardExp) && ManualCardExp.length != 0) {
                  <div class="alert alert-danger"
                    >
                    Invalid Card Expiry Date
                  </div>
                }
                @if (ManualCardExpIsDirty && ManualCardExp.length == 0) {
                  <div class="alert alert-danger">
                    Manual Card Exp is Required
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="manual_form_row mt-3">
            <label>Name on the Card @if (isRequired('mManualCardName')) {
              <span class="required">*</span>
            }</label>
            <div class="inputbox">
              <input type="text" class="form-control" [(ngModel)]="ManualCardName" name="mManualCardName" maxlength="30"
                #mManualCardName="ngModel">
                @if (manualAuthForm.form.get('mManualCardName').errors  &&
                  (manualAuthForm.form.get('mManualCardName').dirty || manualAuthForm.form.get('mManualCardName').touched) &&
                  manualAuthForm.form.get('mManualCardName').validator !== null) {
                  <div class="alert alert-danger">
                    @if (manualAuthForm.form.get('mManualCardName').errors.required) {
                      <span>
                      Card Name is required</span>
                    }
                  </div>
                }
              </div>
            </div>
            <div class="manual_form_row mt-3">
              <label> Card Type @if (isRequired('mCardType')) {
                <span class="required">*</span>
              }</label>
              <div class="inputbox">
                <select class="form-select" name="mCardType" [(ngModel)]="ManualCardType" #mCardType="ngModel"
                  (change)="onChangeManualCard($event)" (keyup)="onChangeManualCard($event)">
                  <option value="0" selected hidden>Select</option>
                  @for (item of creditCardList; track item) {
                    <option [value]="item.Id">{{item.Name}}</option>
                  }
                </select>
                @if (isManualSelectCard) {
                  <div class="alert alert-danger">
                    Card Type is required
                  </div>
                }
              </div>
            </div>
            <div class="manual_form_row mt-3">
              <label>Authorization # @if (isRequired('mManualCardAuthorization')) {
                <span class="required">*</span>
              }</label>
              <div class="inputbox">
                <input type="tel" class="form-control" [(ngModel)]="ManualCardAuthorization" maxlength="16"
                  name="mManualCardAuthorization" #mManualCardAuthorization="ngModel" (keypress)="IsAlphaNumeric($event)">
                  @if (manualAuthForm.form.get('mManualCardAuthorization').errors  &&
                    (manualAuthForm.form.get('mManualCardAuthorization').dirty || manualAuthForm.form.get('mManualCardAuthorization').touched) &&
                    manualAuthForm.form.get('mManualCardAuthorization').validator !== null) {
                    <div class="w-100">
                      @if (manualAuthForm.form.get('mManualCardAuthorization').errors.required) {
                        <span class="alert alert-danger float-start"
                          >
                        Authorization is required</span>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-primary me-3" data-bs-dismiss="modal"
              (click)="OnmanualCancel()">Cancel</button>
              <button type="button" data-bs-dismiss="modal" class="btn btn-primary"
                [disabled]='!ValidManualCardExp || manualAuthForm.invalid || ManualCardAuthorization.length == 0 || isManualSelectCard || ManualCardType.length == 0 || ManualCardType == ""'
              (click)="gotoPaymentSuccess(paymentSuccess, manualAuthAmountPaid)">OK</button>
            </div>
          </ng-template>
        </form>

        <ng-template #selectDevicePopup>
          <div class="modal-header">
            <h5 class="modal-title">Select Device</h5>
            <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="OnCardcancel()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="confirmation_det bg-white mx-auto w-100">
              <label>Please select a Device</label>
              <select class="form-select" [(ngModel)]="selectedDeviceId">
                <option value="0" disabled>Select</option>
                @for (device of terminalDevicesList; track device) {
                  <option [value]="device.Id">{{device.DeviceId}}</option>
                }
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-primary me-3" data-bs-dismiss="modal"
            (click)="OnCardcancel()">Cancel</button>
            <button type="button" data-bs-dismiss="modal" class="btn btn-primary" (click)="onSelectDevice()"
            [disabled]="selectedDeviceId == '0'">Select</button>
          </div>
        </ng-template>
        <ng-template #RefundLimitModal>
          <div class="modal-body">
            <div class="confirmation_det bg-white mx-auto w-100">
              <label>Refund initiated has been sent for Approval</label>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" data-bs-dismiss="modal" class="btn btn-primary" (click)="closeRefundLimitModal()">Ok</button>
          </div>
        </ng-template>

        <form #achManualAuthForm="ngForm">
          <ng-template #achManualAuthorization>
            <div class="modal-header">
              <h5 class="modal-title"> ACH Manual Authorization</h5>
              <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="onACHManualCancel()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body common_form Manual_auth_form">
              <div class="manual_form_row">
                <div class="manual_form_row mt-3">
                  <label>Routing Number <span class="required">*</span></label>
                  <div class="inputbox">
                    <input type="text" class="form-control" [(ngModel)]="routingNumber" maxlength="4" name="achRoutingNumber"
                      #achRoutingNumber="ngModel" (keypress)="numberOnly($event)">
                      @if (achRoutingNumber.invalid  && (achRoutingNumber.dirty || achRoutingNumber.touched)) {
                        <div class="alert alert-danger"
                          >
                          @if (achRoutingNumber.errors.required) {
                            <span>
                            ACH Manual Routing Number is required</span>
                          }
                        </div>
                      }
                    </div>
                  </div>

                  <div class="manual_form_row mt-3">
                    <label>Account Number <span class="required">*</span></label>
                    <div class="inputbox">
                      <input type="text" class="form-control" [(ngModel)]="accountNumber" name="achAccountNumber" maxlength="4"
                        #achAccountNumber="ngModel" (keypress)="numberOnly($event)">
                        @if (achAccountNumber.errors  && (achAccountNumber.dirty ||achAccountNumber.touched)) {
                          <div class="alert alert-danger"
                            >
                            @if (achAccountNumber.errors.required) {
                              <span>
                              ACH Manual Account Number is required</span>
                            }
                          </div>
                        }
                      </div>
                    </div>

                    <div class="manual_form_row mt-3">
                      <label>Check Number <span class="required">*</span></label>
                      <div class="inputbox">
                        <input type="text" class="form-control" [(ngModel)]="checkNumber" name="achCheckNumber" maxlength="15"
                          #achCheckNumber="ngModel" (keypress)="numberOnly($event)">
                          @if (achCheckNumber.errors  && (achCheckNumber.dirty ||achCheckNumber.touched)) {
                            <div class="alert alert-danger"
                              >
                              @if (achCheckNumber.errors.required) {
                                <span>
                                ACH Manual Check Number is required</span>
                              }
                            </div>
                          }
                        </div>
                      </div>
                      <div class="manual_form_row mt-3">
                        <label>Account Type <span class="required">*</span></label>
                        <div class="inputbox">
                          <select class="form-select" [(ngModel)]="accountType" name="achAccountType" #achAccountType="ngModel"
                            (change)="onChangeAccounType($event)">
                            <option [value]="279">Checking</option>
                            <option [value]="278">Savings</option>
                          </select>
                          @if (achManualAuthForm.form.get('achAccountType').errors  &&
                            (achManualAuthForm.form.get('achAccountType').dirty || achManualAuthForm.form.get('achAccountType').touched) &&
                            achManualAuthForm.form.get('achAccountType').validator !== null) {
                            <div class="alert alert-danger">
                              @if (achManualAuthForm.form.get('achAccountType').errors.required) {
                                <span>
                                Account Type is required</span>
                              }
                            </div>
                          }
                        </div>
                      </div>
                      <div class="manual_form_row mt-3">
                        <label>Name on Account</label>
                        <div class="inputbox">
                          <input type="text" class="form-control" [(ngModel)]="nameonAccount " name="achNameOnAccount" maxlength="30"
                            #achNameOnAccount="ngModel">
                          </div>
                        </div>
                        <div class="manual_form_row mt-3">
                          <label>Authorization # <span class="required">*</span></label>
                          <div class="inputbox">
                            <input type="tel" class="form-control" [(ngModel)]="achManualCardAuthorization" maxlength="16"
                              name="achAuthorization" #achAuthorization="ngModel" (keypress)="IsAlphaNumeric($event)">
                              @if (achAuthorization.invalid  && (achAuthorization.dirty || achAuthorization.touched)) {
                                <div class="alert alert-danger"
                                  >
                                  @if (achAuthorization.errors.required) {
                                    <span>
                                    Authorization is required</span>
                                  }
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-outline-primary me-3" data-bs-dismiss="modal"
                        (click)="onACHManualCancel()">Cancel</button>
                        <button type="button" data-bs-dismiss="modal" class="btn btn-primary"
                          [disabled]='achManualAuthForm.invalid || achManualCardAuthorization.length == 0 || checkNumber === "" || routingNumber === "" || accountNumber === ""'
                        (click)="gotoPaymentSuccess(paymentSuccess, manualAuthAmountPaid)">OK</button>
                      </div>
                    </ng-template>
                  </form>

                  <ng-template #StripeRefund>
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title">Hosted Page Refund</h5>
                        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="closeStripeForm()">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <form id ="payment-form" autocomplete="off">
                          <div class="card_box mb-2">
                            <label for="card-element">Card Number</label>
                            <div id="card-element" class="card_input"></div>
                          </div>
                          <div id="address-element"></div>
                          <button id="submit" style="display: none;">
                            <div class="spinner hidden" id="spinner"></div>
                            <span id="button-text">Pay</span>
                          </button>
                        </form>
                      </div>

                      <div class="modal-footer">
                        <label  class="pure-material-checkbox float-start">
                          <input type="checkbox" class="checkBoxClass"
                            (change)="onClickStripeAutoPopulateBillingInfo($event.target.checked)">
                            <span class="charitypay_text mt-0">Auto Populate Customer Information</span>
                          </label>

                          <div class="pay_rgt_butt">
                            <button type="button" class="btn btn-outline-primary me-3" (click)="closeStripeForm()">Cancel</button>
                            <button (click)="onStripePay()" class="btn btn-primary">Make Payment</button>
                          </div>
                        </div>
                      </div>
                    </ng-template>
